var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"header":"Edit Question"}},[(_vm.pollLoaded)?_c('poll-form',{attrs:{"submit":_vm.editPoll,"poll":_vm.poll}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }